import {useEffect} from 'react'

import {dispatch, useSelector} from '../../store.js'
import {TRANSFER_LIST_PAGE} from '../../common/constants/Pages.js'
import {TRANSFER_URI_COMPONENT} from '../../common/constants/Transfers.js'
import {setCurrentPage} from '../../redux/actions/ui/index.js'
import {locationSelector} from '../../redux/selectors/ui/location.js'
import {setupTransferListForm} from './transferListFunctions.js'

export default function TransferListLocationListener() {
  const {
    pathComponents: [resource, transferID],
  } = useSelector(locationSelector)
  const isThisPage = resource === TRANSFER_URI_COMPONENT && !transferID

  useEffect(() => {
    setupTransferListForm()
  }, [])

  useEffect(() => {
    if (!isThisPage) {
      return
    }

    dispatch(setCurrentPage(TRANSFER_LIST_PAGE))
  }, [isThisPage])

  return null
}
